// declare process variable
declare const process: {
    env: {
        NODE_ENV: string,
    },
};

export const isTestEnvironment = (): boolean =>
    ['test', 'test:chrome:plugin'].includes(
        process.env.NODE_ENV as string,
    );
